import React from "react";
import { ShoppingBag, Search, Eye } from "lucide-react";


export default function Dashboard4() {
  const orders = [
    {
      id: 1,
      status: "Processing",
      color: "bg-cyan-600",
      customer: "Steve Gates (steve_gates@routekart.com)",
      date: "02/11/2025 10:34:46 PM",
    },
    {
      id: 2,
      status: "Pending",
      color: "bg-yellow-500",
      customer: "Arthur Holmes (arthur_holmes@routekart.com)",
      date: "02/11/2025 10:34:46 PM",
    },
    {
      id: 3,
      status: "Pending",
      color: "bg-yellow-500",
      customer: "James Pan (james_pan@routekart.com)",
      date: "02/11/2025 10:34:46 PM",
    },
    {
      id: 4,
      status: "Processing",
      color: "bg-cyan-600",
      customer: "Brenda Lindgren (brenda_lindgren@routekart.com)",
      date: "02/11/2025 10:34:46 PM",
    },
    {
      id: 5,
      status: "Complete",
      color: "bg-green-600",
      customer: "Victoria Terces (victoria_victoria@routekart.com)",
      date: "02/11/2025 10:34:46 PM",
    },
  ];

  const keywords = [
    { keyword: "computer", count: 34 },
    { keyword: "camera", count: 30 },
    { keyword: "jewelry", count: 27 },
    { keyword: "shoes", count: 26 },
    { keyword: "jeans", count: 19 },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
      {/* Latest Orders */}
      <div className="bg-white rounded-md shadow border overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-4 py-2">
          <div className="flex items-center gap-2 text-gray-700 font-semibold">
            <ShoppingBag size={18} />
            Latest Orders
          </div>
          <button className="bg-sky-500 hover:bg-sky-600 text-white text-sm font-medium px-3 py-1 rounded">
            View All Orders
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border-collapse">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="px-4 py-2 border">Order #</th>
                <th className="px-4 py-2 border">Order status</th>
                <th className="px-4 py-2 border">Customer</th>
                <th className="px-4 py-2 border">Created on</th>
                <th className="px-4 py-2 border">View</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2 border">{order.id}</td>
                  <td className="px-4 py-2 border">
                    <span
                      className={`${order.color} text-white px-3 py-1 rounded text-xs font-medium`}
                    >
                      {order.status}
                    </span>
                  </td>
                  <td className="px-4 py-2 border">{order.customer}</td>
                  <td className="px-4 py-2 border whitespace-nowrap">
                    {order.date}
                  </td>
                  <td className="px-4 py-2 border text-center">
                    <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-medium px-3 py-1 rounded">
                      <Eye size={14} /> View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Pagination */}
        <div className="flex justify-between items-center border-t px-4 py-2 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <button className="border px-3 py-1 rounded-l bg-white hover:bg-gray-100">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-3 py-1">1</button>
            <button className="border px-3 py-1 rounded-r bg-white hover:bg-gray-100">
              Next
            </button>
          </div>
          <span>1-5 of 5 items</span>
        </div>
      </div>

      {/* Popular Search Keywords */}
      <div className="bg-white rounded-md shadow border overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between border-b px-4 py-2">
          <div className="flex items-center gap-2 text-gray-700 font-semibold">
            <Search size={18} />
            Popular search keywords
          </div>
          <button className="text-gray-400 text-xl font-bold hover:text-gray-600">
            –
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border-collapse">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="px-4 py-2 border">Keyword</th>
                <th className="px-4 py-2 border">Count</th>
              </tr>
            </thead>
            <tbody>
              {keywords.map((item, index) => (
                <tr key={index} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2 border">{item.keyword}</td>
                  <td className="px-4 py-2 border">{item.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Pagination */}
        <div className="flex justify-between items-center border-t px-4 py-2 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <button className="border px-3 py-1 rounded-l bg-white hover:bg-gray-100">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-3 py-1">1</button>
            <button className="border px-3 py-1 rounded-r bg-white hover:bg-gray-100">
              2
            </button>
            <button className="border px-3 py-1 rounded-r bg-white hover:bg-gray-100">
              Next
            </button>
          </div>
          <span>1-5 of 6 items</span>
        </div>
      </div>
      
    </div>
  );
}
